export let Notification;
(function (_Notification) {
  let Style = /*#__PURE__*/function (Style) {
    Style["SUCCESS"] = "success";
    Style["INFO"] = "info";
    Style["WARNING"] = "warning";
    Style["DANGER"] = "danger";
    return Style;
  }({});
  _Notification.Style = Style;
})(Notification || (Notification = {}));